import { useQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../config/api-endpoints';
import authService from '../services/authService';

export interface ClassSharedFile {
  id: number;
  class_id: number;
  file_name: string;
  file_url: string;
  file_type: string;
  file_size: number;
  description: string;
  uploaded_by: number;
  created_at: string;
  updated_at: string;
}

// Hook to get class shared files by ClassId
export function useClassSharedFiles(classId: string | number) {
  return useQuery({
    queryKey: ['classSharedFiles', classId],
    queryFn: async () => {
      const baseURL = process.env.REACT_APP_API_URL || 'https://eft-assured-early.ngrok-free.app/api';
      const url = `${baseURL}${API_ENDPOINTS.GET_CLASS_SHARED_FILES(classId.toString())}`;
      
      console.log('Fetching class shared files for class ID:', classId);
      console.log('Full URL:', url);
      
      const res: any = await (await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authService.getToken()}`,
        },
      })).json();
      
      console.log('Class Shared Files API Response:', res);

      if (res.error) {
        console.error('Class shared files error:', res.error);
        throw new Error('Failed to fetch class shared files');
      }
      
      // Return the data array
      const filesData = res.data || res;
      console.log('Processed Class Shared Files Data:', filesData);
      return Array.isArray(filesData) ? filesData : [filesData] as ClassSharedFile[];
    },
    enabled: !!classId,
  });
}
